import styled from "@emotion/styled";
import { neutralDark40 } from "../../../constants/colors";
import { Button } from "../../button";

export const StyledActionButton = styled(Button)`
    height: 32px;
    color: ${neutralDark40};
`;
